const NoDataCard = () => {
  return (
    <div className='flex flex-col h-full w-full print:p-8 min-h-32'>
      <div className='m-auto'>No data for selected filters</div>
    </div>
  );
};

export default NoDataCard;
